import { EAccess, EAccessMethod } from "@app/access/access.model";
import { EvideTableColumn, EvideTableColumnComponent, EvideTableColumnType } from "../common/common.model";

export interface INotificationTemplateHttpResponse {
  id: number;
  referenceGuid: string;
  typeCode: string;
  description: string;
}

export class NotificationTemplate {
  constructor(
    public id: number,
    public referenceGuid: string,
    public typeCode: string,
    public description: string
  ) { }

  public static adapt(data: INotificationTemplateHttpResponse) {
    return new this(
      data.id,
      data.referenceGuid,
      data.typeCode,
      data.description
    );
  }

  public static createBlank() {
    return new this(0, '', '', '');
  }
}

export const NotificationTemplateColumns: Readonly<EvideTableColumn[]> = [
  {
    key: 'referenceGuid',
    type: EvideTableColumnType.Text,
    compType: EvideTableColumnComponent.Input,
    isFormField: true,
    isFormEditableField: true,
    title: 'Reference Guid',
    displayValue: true,
    required: true,
    required_error: 'Reference Guid is Required',
    sortable: true,
    pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$'
  },
  {
    key: 'typeCode',
    type: EvideTableColumnType.Text,
    compType: EvideTableColumnComponent.Input,
    isFormField: true,
    isFormEditableField: true,
    title: 'Type Code',
    displayValue: true,
    required: true,
    required_error: 'Type Code is Required',
    sortable: true
  },
  {
    key: 'description',
    type: EvideTableColumnType.Text,
    compType: EvideTableColumnComponent.Textarea,
    isFormField: true,
    isFormEditableField: true,
    title: 'Description',
    displayValue: true,
    required: false,
    sortable: true
  },
  {
    key: 'options',
    type: EvideTableColumnType.Options,
    matIcon: 'more_vert',
    title: 'Options',
    optionMenu: [
      {
        key: 'view_sub',
        type: EvideTableColumnType.Action,
        matIcon: 'fas fa-arrow-right',
        title: 'Template Parameter',
        accessVisibility: {
          controllerKey: EAccess.NotificationTemplateParameter,
          methodKey: EAccessMethod.GetNotificationTemplateParameterList
        }
      },
      {
        key: 'edit',
        type: EvideTableColumnType.Action,
        matIcon: 'fa fa-fw fa-pen',
        title: 'Edit',
        accessVisibility: {
          controllerKey: EAccess.NotificationTemplate,
          methodKey: EAccessMethod.Put
        }
      },
      {
        key: 'delete',
        type: EvideTableColumnType.Action,
        matIcon: 'fa fa-fw fa-trash-alt',
        title: 'Delete',
        accessVisibility: {
          controllerKey: EAccess.NotificationTemplate,
          methodKey: EAccessMethod.Delete
        }
      }
    ]
  }
];